import { defineStore } from 'pinia'
import moment from 'moment'
import { DASHBOARD_QUOTES } from '@/data/url'
import apiClient from '@/services/apiClient'

const defaultState = () => ({
    figureKey: 0,
    customer: '',
    vendor: '',
    user: '',
    date_range: 'this_quarter',
    range: [moment().startOf('quarter').toDate(), moment().endOf('quarter').toDate()],
    queryDataRaw: [],
    loading: false,
    error: null,
})

export const useDashboardQuotesStore = defineStore('dashboardQuotes', {
    state: () => ({
        ...defaultState(),
    }),
    actions: {
        resetDashboardQuotesState() {
            this.queryDataRaw = []
            this.customer = ''
            this.vendor = ''
            this.user = ''
            this.date_range = 'this_quarter'
            this.range = [moment().startOf('quarter').toDate(), moment().endOf('quarter').toDate()]
            this.loading = false
            this.error = null
        },
        setQueryDataRaw(data) {
            this.queryDataRaw = data
        },
        addToFigureKey(addValue) {
            this.figureKey += addValue
        },
        setRange(range) {
            this.range = range
        },
        async fetchDashboardQuotes({
            begin_date,
            end_date,
            customer = this.customer,
            vendor = this.vendor,
            user_id = this.user,
        } = {}) {
            this.loading = true
            this.error = null
            this.setQueryDataRaw([])

            try {
                const response = await apiClient.post(DASHBOARD_QUOTES, {
                    begin_date,
                    end_date,
                    customer,
                    vendor,
                    user_id,
                })

                const data = response.data
                if (data?.success) {
                    this.setQueryDataRaw(data.data || [])
                } else {
                    this.setQueryDataRaw([])
                }

                return data
            } catch (error) {
                this.error = error instanceof Error ? error.message : 'Unknown error'
                console.error('Failed to fetch dashboard quotes', error)
                throw error
            } finally {
                this.loading = false
            }
        },
    },
})
